const lbTimeSelect = angular.module('app.lbTimeSelect', []);

lbTimeSelect.controller('lbTimeSelectCtrl', require('./lbTimeSelectCtrl'));
lbTimeSelect.component('lbTimeSelect', require('./lbTimeSelect'));

export default lbTimeSelect;



// WEBPACK FOOTER //
// ./src/components/lbTimeSelect/index.js